import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import { DropDown } from "../../assets/icons/icon";
import { HeadingText } from "..";
import styles from "./styles.module.css";

const ExpandableWrapper = ({
  title = "Expand",
  subtitle,
  children,
  className,
  height,
  expanded,
  setExpanded,
  id = "",
}) => {
  const handleChange = () => setExpanded(!expanded);

  return (
    <Box
      className={`${styles.stickyRoot} ${className || ""}`}
    >
      <Accordion
        expanded={expanded}
        onChange={handleChange}
        sx={{
          boxShadow: "none",
          borderBottom: "none",
          "&:before": { display: "none" },
          overflow: "visible",
          background: "transparent",
        }}
      >
        <AccordionSummary
          className={styles.summary}
          expandIcon={<DropDown width={"1.2rem"} height={"1.2rem"} />}
          aria-controls="panel1a-content"
          id={id || "expandable-header"}
        >
          <HeadingText
            className={`${styles.title} fontSize14 fontWeight400 newFontColor`}
          >
            {title}
          </HeadingText>
          {subtitle && (
            <span className={styles.subtitle}>{subtitle}</span>
          )}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            height: expanded ? height : "0",
            maxHeight: expanded ? height : "0",
            overflow: expanded ? "visible" : "hidden",
            transition: `${height} 2.3s ease`,
            padding: "8px 8px 16px",
          }}
          className="generic-scrollbar"
        >
          {children}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ExpandableWrapper;
